import React from 'react'
import {SignInMethod} from '../../modules/accounts/components/settings/cards/SignInMethod'
import CreateNewPassword from './CreateNewPassword'
import NewSubAdmin from './NewSubAdmin'

const NewSubAdminPage = () => {
  return (
    <div>
      <NewSubAdmin />
      {/* <CreateNewPassword /> */}
    </div>
  )
}

export default NewSubAdminPage
